import React, { createContext, useContext, useState } from 'react';
import Api from '../utils/Api'; 
import { useAuth } from '../context/AuthContext';
import { useError } from '../context/ErrorContext';

const ResetPasswordContext = createContext();

export const useResetPassword = () => {
  const context = useContext(ResetPasswordContext);
  if (!context) {
    throw new Error('useResetPassword must be used within a ResetPasswordProvider');
  }
  return context;
};
 
export const ResetPasswordProvider = ({ children }) => {
  const { user, getToken } = useAuth();
  const [api, setApi] = useState(null);
  const { handleApiError, formErrors, clearErrors } = useError();

  // Initialize API with token getter
  React.useEffect(() => {
    setApi(Api(() => getToken()));
  }, [user, getToken]);

  const resetPassword = async (data) => {
    clearErrors();
    const response = await api.call('password/reset', 'POST', data, true);
    console.log('reset-password-response', response);
    
    if(response.status === 200){
      return {'status': response.status};
    } else {
      if(response.error.status === 422){
        return {'status': response.error.status, 'errors': response.error.validationErrors};
      } else {
        return handleApiError(response.error, {
          showAlert: false,
          redirectOn401: true,
          customMessage: 'Failed to reset password'
        });
      }
    }
  };

  return (
    <ResetPasswordContext.Provider value={{ resetPassword, formErrors }}>
      {children}
    </ResetPasswordContext.Provider>
  );
}; 